// plugins/vconsole.client.ts
import VConsole from 'vconsole'

export default defineNuxtPlugin(() => {
    // 只在特定环境启用（例如开发环境或预发布环境）
    const isDev = import.meta.env.DEV || process.env.NODE_ENV === 'development'
    const enableVconsole = isDev || import.meta.env.VITE_ENABLE_VCONSOLE === 'true'

    if (enableVconsole) {
        const vConsole = new VConsole()
        console.log('🪄 vConsole 已启用:', vConsole.version)
    } else {
        console.log('🚫 vConsole 已禁用（生产环境）')
    }
})
